<template>
  <div>
    <!-- <CCard> -->
      <!-- <CCardHeader>
        <CRow>
          <CCol>
            <strong>{{ $t("ticketingQueue.title") }}</strong>
          </CCol>
        </CRow>
      </CCardHeader> -->
      <!-- <CCardBody> -->
         <!-- <div v-if="isShowSelectAgent">
            
                <cAgent
                v-model="agency"
                :ctrlName="'agencyname'"
                :ctrlCode="'b2bid'"
                :isShowCode="true"
                :isSearchable="true"
                v-on:input="getAgentDetails"
                class="bs-input"
              />
         
         </div> -->
         <!-- <div v-if="!isShowSelectAgent"> -->
         <div v-if="isShowTable" class="ticketing_queue">


          <cTicketingQueue 
            :ticketingQueueResponse="ticketingQueueResponse" 
            :ticketingQueueField="ticketingQueueField" 
            @nav="navToTicketNowPage"

            @showModal="showAlertModal" 
            @search="getTicketingQueueList"
            :isBooking="false"
            :isTicketNow="isTicketNow"
            :filterObject="ticketingObj"
                        :orderStatusCount="statusCount"

          ></cTicketingQueue>
          </div>      
        <!-- </div> -->
      <!-- </CCardBody> -->
    <!-- </CCard> -->
     <CModal
      :show.sync="isShowModal"
      :closeOnBackdrop="false"
      centered
      >
      </CModal>
      <cAlertModal
      :buttonList="modalButton"
      :status="modalStatus"
      :isShowIcon="false"
      :show="isShowAlertModal"
      :desc="confirmTxt"
    ></cAlertModal>
  <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>  </div>
</template>

<script>

import {
  COMPONENT_NAME,
  PATHNAME,
  TRIP,
  DEFAULT_DROPDOWN_STATUS,
  ALERT_MODAL_STATUS
} from "../../../../util/constants";
import apiGetTicketingQueueList from "../../../../services/apiGetTicketingQueueList";
import BaseConfiguration from "../../../../config/base";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  cloneData,
  removeDuplicates,
  OrderByList
} from "../../../../util/util";
import Logger from "../../../../services/logger";
import { mapGetters, mapActions } from "vuex";
//import Multiselect from "vue-multiselect";
//import cAgent from "../../../../components/form/cAgent";
import router, { navigate, goBack } from "../../../../router/index";
import cAlertModal from "../../../../components/form/cAlertModal";
//import datePicker from 'vue-range-datechooser';
import {formatDate} from "../../../../util/date/dateFunctions";
import cTicketingQueue from "../../../../components/ticketing/cTicketingQueue";
import {subDays} from "../../../../util/date/dateFunctions"
import { addClassToBody,removeClassBody } from "../../../../util/util";

export default {
  name: COMPONENT_NAME.TICKETING_QUEUE,

  components: {
    cTicketingQueue,
   // Multiselect,
    //cAgent,
    cAlertModal,
   // datePicker
  },

  data() {
    return {
      ticketingQueueResponse: [],
      isTicketNow:false,
      ticketingQueueField: [],
      alertValue: null,
      isShowModal: false,
      isShowAlertModal: false,
      modalStatus: ALERT_MODAL_STATUS.INFO,
      confirmTxt: null,
      modalButton: [],
      isShowTable: false,
       ticketingObj: {
    "orderId": null,
    "pnr":null,
    "firstName": null,
    "lastName": null,
    "departure": null,
    "arrival": null,
    "journeyType": null,
    "travelDateFrom": null,
    "travelDateTo": null,
    "airline": null,
    "b2bid": null,
    "userId":null,
    "ticketNumber":null,
    "bookingDateFrom": null,
    "bookingDateTo": null,
    b2bGroupId:null
},
statusCount:null
    };
  },
  // computed: {
   
    
  // },

  methods: {
    ...mapActions("cTicketingDetail", {
     SET_FILTER_SEARCH_OBJ: "SET_FILTER_SEARCH_OBJ",
     SET_TICKETING_QUEUE_RES:"SET_TICKETING_QUEUE_RES"
    }),
  ...mapActions("sTicketingQueue", {
     SET_TICK_QUEUE_REQ: "SET_TICK_QUEUE_REQ",
     SET_ORDER_ID: "SET_ORDER_ID"
    }),
     ...mapActions("sCPaymentList", {
     SET_CURRENCY: "SET_CURRENCY"
    }),
    showAlert(val) {
      this.alertValue = val;
    },

    toggleShowAlertModal(){
      this.isShowAlertModal = !this.isShowAlertModal
    },

    navToTicketNowPage(pTicketingDet) {
        try {
          if(BaseConfiguration.isDebug) console.log("navToTicketNowPage");
          if(this.AGENT_SIGNIN_RES){        
          if(pTicketingDet){     
                 this.SET_TICK_QUEUE_REQ(pTicketingDet);

         this.SET_CURRENCY( this.formatCurrency(pTicketingDet.currency));

          }
          this.isTicketNow=true;
          navigate(PATHNAME.TICKET_NOW);
          }
          else if(this.ADMIN_SIGNIN_RES){
            this.SET_ORDER_ID(pTicketingDet.orderId)
            navigate(PATHNAME.SYSTEM_TICKET_NOW);
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TICKETING_QUEUE,
                  "error in navToTicketNowPage",
                  err.toString(),
                  "navToTicketNowPage",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
         formatCurrency(pCurrency) {
                try {
                  if(BaseConfiguration.isDebug) console.log("formatCurrency");
                  let currency=null;
                  if(pCurrency){
                  if(pCurrency.constructor==Array){
                    for(let i=0;i<pCurrency.length;i++){
                      if(pCurrency[i].hasOwnProperty('currency_code')){
                        currency=pCurrency[i].currency_code.code;
                      }else if(pCurrency[i].hasOwnProperty('code')){
                        currency=pCurrency[i].code;
                      }
                    }
                  }else if(pCurrency.constructor==Object){
                     if(pCurrency.hasOwnProperty('currency_code')){
                        currency=pCurrency.currency_code.code;
                      }else if(pCurrency.hasOwnProperty('code')){
                        currency=pCurrency.code;
                      }
                  }else{
                    currency=pCurrency;
                  }

                }
                return currency;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.TICKETING_QUEUE,
                          "error in formatCurrency",
                          err.toString(),
                          "formatCurrency",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
                }, 

    showAlertModal(status, val) {
      this.isShowAlertModal = true;
      this.modalStatus = status;
      if(status == ALERT_MODAL_STATUS.INFO){
         this.modalButton = [
        {
          name: this.$t("ticketingQueue.cancel"),
          func: this.toggleShowAlertModal,
          color: "danger"
        },
        {
          name: this.$t("ticketingQueue.okBtn"),
          func: this.cancelBooking,
          color: "success"
        }
      ];
      }else if(status == ALERT_MODAL_STATUS.SUCCESS){
      this.modalButton = [
        {
          name: this.$t("ticketingQueue.okBtn"),
          func: this.navigateToManageAgents,
          color: "success"
        }
      ];
      }
      this.confirmTxt = val;
    },

    cancelBooking() {
        try {
          if(BaseConfiguration.isDebug) console.log("cancelBooking");
          //let retValue;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TICKETING_QUEUE,
                  "error in cancelBooking",
                  err.toString(),
                  "cancelBooking",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         // return retValue;
        }, 

    async getTicketingQueueList(ticketingObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("getTicketingQueueList");
        //let retValue;
        //let TicketQList;
        if(ticketingObj)
        {
        this.SET_FILTER_SEARCH_OBJ(ticketingObj);
        if(this.AGENT_SIGNIN_RES && this.AGENT_DET){
         // ticketingObj.b2bid = this.AGENT_DET.b2bid;
         ticketingObj.b2bid = [];
         ticketingObj.b2bid.push(this.AGENT_DET.b2bid);
        }
        let ticketQReq = apiGetTicketingQueueList.buildRequest(ticketingObj);

        if (ticketQReq) {
          let ticketQRes = await apiGetTicketingQueueList.getResponse(
            ticketQReq
          );
          if (VALIDATE_SUCCESS_RES(ticketQRes)) {
            this.SET_TICKETING_QUEUE_RES(ticketQRes.data.data)
            this.ticketingQueueResponse = ticketQRes.data.data.bookings;
                                     this.statusCount=ticketQRes.data.data.statusCount;

           this.ticketingQueueResponse = OrderByList(this.ticketingQueueResponse,'ticketingdeadline','asc');
            this.showAlert(null);
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(ticketQRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
        }
        else
        {
          this.ticketingQueueResponse=[]
          this.statusCount=[]
        }

        //return TicketQList;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.TICKETING_QUEUE,
          "error in getTicketingQueueList",
          err.toString(),
          "getTicketingQueueList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

        getAgentDataField(){
           if (BaseConfiguration.isDebug) console.log("getAgentDataField");
           return [
        // {
        //   key: "bookingDate",
        //   label: this.$t("ticketingQueue.bookDate")
        // },
         {
          key: "bookingStatus",
          label: this.$t("ticketingQueue.status"),
          isLocked: true
         // sorter: false
        },
        {
          key: "orderId",
          label: this.$t("ticketingQueue.resId"),
          isLocked: true
         // sorter: false
        },
        {
          key: "passengername",
          label: this.$t("ticketingQueue.name"),
          isLocked:  false
          //sorter: false
        },
        // {
        //   key: "contactmail",
        //   label: this.$t("ticketingQueue.mail")
        // },
        {
          key: "contactmail",
          label: this.$t("ticketingQueue.contact"),
          isLocked: false
          //sorter: false
        },
        // {
        //   key: "airline",
        //   label: this.$t("ticketingQueue.airline")
        // },
        {
          key: "journeytype",
          label: this.$t("ticketingQueue.route"),
          isLocked: false
          //sorter: false
        },
        // {
        //   key: "arrival",
        //   label: this.$t("ticketingQueue.arrival")
        // },
        // {
        //   key: "journeytype",
        //   label: this.$t("ticketingQueue.journeyType")
        // },
        {
          key: "flight_number",
          label: this.$t("ticketingQueue.flightNumber"),
          isLocked: false
         // sorter: false
        },
        {
          key: "departuredate",
          label: this.$t("ticketingQueue.travelDate"),
          isLocked: false
         // sorter: false
        },
        // {
        //   key: "retDate",
        //   label: this.$t("ticketingQueue.retDate")
        // },
        {
          key: "pnr",
          label: this.$t("ticketingQueue.pnr"),
          isLocked: false
         // sorter: false
        },
        {
          key: "username",
          label: this.$t("ticketingQueue.bookedBy"),
          isLocked: false
         // sorter: false
        },
        {
          key: "amount",
          label: this.$t("ticketingQueue.amount"),
          isLocked: false
         // sorter: false
        }, 
        {
          key: "ticketingdeadline",
          label: this.$t("ticketingQueue.deadLine"),
          isLocked: true
         // sorter: true
        },
        // {
        //   key: "currency",
        //   label: this.$t("ticketingQueue.currency")
        // },       
        {
          key: "actions",
          label: this.$t("ticketingQueue.actions"),
          sorter: false,
          isLocked: true
        }
      ];

        },

        getAdminDataField(){
           if (BaseConfiguration.isDebug) console.log("getAdminDataField");
            return [
        // {
        //   key: "bookingDate",
        //   label: this.$t("ticketingQueue.bookDate")
        // },
         {
          key: "bookingStatus",
          label: this.$t("ticketingQueue.status"),
           isLocked: true
         // sorter: false
        },
        {
          key: "orderId",
          label: this.$t("ticketingQueue.resId"),
           isLocked: true
         // sorter: false
        },
        {
          key: "passengername",
          label: this.$t("ticketingQueue.name"),
           isLocked: false
         // sorter: false
        },
        // {
        //   key: "contactmail",
        //   label: this.$t("ticketingQueue.mail")
        // },
        {
          key: "contactmail",
          label: this.$t("ticketingQueue.contact"),
           isLocked: false
         // sorter: false
        },
        // {
        //   key: "airline",
        //   label: this.$t("ticketingQueue.airline")
        // },
        {
          key: "journeytype",
          label: this.$t("ticketingQueue.route"),
           isLocked: false
         // sorter: false
        },
        // {
        //   key: "arrival",
        //   label: this.$t("ticketingQueue.arrival")
        // },
        // {
        //   key: "journeytype",
        //   label: this.$t("ticketingQueue.journeyType")
        // },
        {
          key: "flight_number",
          label: this.$t("ticketingQueue.flightNumber"),
          isLocked: false
         // sorter: false
        },
        {
          key: "departuredate",
          label: this.$t("ticketingQueue.travelDate"),
          isLocked: false
          //sorter: false
        },
        // {
        //   key: "retDate",
        //   label: this.$t("ticketingQueue.retDate")
        // },
        {
          key: "pnr",
          label: this.$t("ticketingQueue.pnr"),
          isLocked: false
         // sorter: false
        },
        {
          key: "agencyname",
          label: this.$t("ticketingQueue.bookedBy"),
          isLocked: false
         // sorter: false
        },
        {
          key: "amount",
          label: this.$t("ticketingQueue.amount"),
          isLocked: false
         // sorter: false
        }, 
        {
          key: "ticketingdeadline",
          label: this.$t("ticketingQueue.deadLine"),
          isLocked: true
        //  sorter: true
        },
        {
          key: "actions",
          label: this.$t("ticketingQueue.actions"),
          sorter: false,
          isLocked: true
        }
        // {
        //   key: "currency",
        //   label: this.$t("ticketingQueue.currency")
        // },       
      ];

        },

    getTicketingQueueField() {
       if (BaseConfiguration.isDebug) console.log("getTicketingQueueField");
        if(this.AGENT_SIGNIN_RES){
         return this.getAgentDataField();
     
        }else if(this.ADMIN_SIGNIN_RES){
          return  this.getAdminDataField();
        }
    }
  },

  computed: {
    ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
    ...mapGetters("sAgtLogin", {
      AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
    }),
    ...mapGetters("sDashBoard", {
      AGENT_DET: "GET_AGENT_LOGO_DET_RES"
    }),
     ...mapGetters("sCSearch", {
      sSearchObj: "GET_SEARCH_OBJ"
    }),
 ...mapGetters("cTicketingDetail", {
             
                 GET_TICKETING_QUEUE_RES:"GET_TICKETING_QUEUE_RES"

            }),
  },

  async created() {

        this.$root.$emit("toggle-sidebar-minimize", true);
  let date = new Date();
 this.ticketingObj.bookingDateFrom = new Date(date.getFullYear(), date.getMonth(), 1);
  this.ticketingObj.bookingDateTo = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    //let b2bid = this.AGENT_SIGNIN_RES ? this.AGENT_SIGNIN_RES.b2bid : this.ADMIN_SIGNIN_RES ? this.ADMIN_SIGNIN_RES.b2bid : null;
    let b2bid;
    if (this.AGENT_SIGNIN_RES && this.AGENT_DET) {
      b2bid = this.AGENT_DET.b2bid;
    }else 
    if(this.ADMIN_SIGNIN_RES){
       b2bid = null;
//         let date = new Date();
//  this.ticketingObj.bookingDateFrom = new Date(date.getFullYear(), date.getMonth(), 1);
      //  this.ticketingObj.bookingDateFrom = subDays(new Date(),10);
      // this.ticketingObj.bookingDateTo = new Date();
       this.isShowTable = true;
    } 
    if(b2bid) {
      this.ticketingObj.b2bid = [];
      this.ticketingObj.b2bid.push(b2bid);
       if(this.GET_TICKETING_QUEUE_RES){
      this.ticketingQueueResponse=this.GET_TICKETING_QUEUE_RES.bookings;
        this.statusCount=this.GET_TICKETING_QUEUE_RES.statusCount;

    }else{
    await this.getTicketingQueueList(this.ticketingObj);

    }
    }
    if(this.ticketingQueueResponse)  this.isShowTable = true;
    

    //if (this.ticketingQueueResponse) {
      this.ticketingQueueField = this.getTicketingQueueField();
    //}
    if(this.GET_TICKETING_QUEUE_RES){
      this.ticketingQueueResponse=this.GET_TICKETING_QUEUE_RES.bookings;
                                           this.statusCount=this.GET_TICKETING_QUEUE_RES.statusCount;

    }
      

  },
    beforeCreate() {    
   addClassToBody(COMPONENT_NAME.TICKETING_QUEUE);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>
